/**
 * ApiKeysService — console-issued API keys, served by CCMS.Api.UserManagement (gateway prefix `users`).
 *
 * Routes — /api/api-keys   (ApiKeys.View to read, ApiKeys.Manage to change; Admin has both)
 *   - GET  /                    list (never secrets)
 *   - GET  /options             roles, rights and service names for the form
 *   - GET  /{id}
 *   - POST /                    issue → returns the secret ONCE
 *   - PUT  /{id}                name, email, description, roles, rights, expiry, services, active
 *   - POST /{id}/renew          new expiry (null = permanent); rotateSecret → new secret once
 *   - POST /{id}/rotate         new secret once; old one dies immediately
 *   - POST /{id}/revoke         final
 *   - POST /resync              push every key to Redis now
 */
import { BaseService } from '../base/BaseService';
export class ApiKeysService extends BaseService {
    constructor(http, config) {
        super(http, { servicePath: config?.servicePath ?? ApiKeysService.DEFAULT_SERVICE_PATH, basePath: ApiKeysService.BASE_PATH, endpoints: config?.endpoints });
    }
    unwrap(r, fallback) {
        if (!r.data)
            throw new Error(r.message ?? fallback);
        return r.data;
    }
    async list() {
        return (await this.http.get(this.buildUrl())).data ?? [];
    }
    async options() {
        return this.unwrap(await this.http.get(this.buildUrl(this.getEndpoint('options', 'options'))), 'Could not load options');
    }
    async get(id) {
        return this.unwrap(await this.http.get(this.buildUrl(this.getEndpoint('get', `${id}`))), 'Key not found');
    }
    /** The returned `secret` is shown once — never stored. */
    async create(request) {
        return this.unwrap(await this.http.post(this.buildUrl(), request), 'Could not issue the key');
    }
    async update(id, request) {
        return this.unwrap(await this.http.put(this.buildUrl(this.getEndpoint('update', `${id}`)), request), 'Could not save the key');
    }
    async renew(id, request) {
        return this.unwrap(await this.http.post(this.buildUrl(this.getEndpoint('renew', `${id}/renew`)), request), 'Could not renew the key');
    }
    async rotate(id) {
        return this.unwrap(await this.http.post(this.buildUrl(this.getEndpoint('rotate', `${id}/rotate`)), {}), 'Could not rotate the key');
    }
    async revoke(id, request = {}) {
        return this.unwrap(await this.http.post(this.buildUrl(this.getEndpoint('revoke', `${id}/revoke`)), request), 'Could not revoke the key');
    }
    async resync() {
        return (await this.http.post(this.buildUrl(this.getEndpoint('resync', 'resync')), {})).data ?? 0;
    }
}
ApiKeysService.DEFAULT_SERVICE_PATH = 'users';
ApiKeysService.BASE_PATH = 'api/api-keys';
//# sourceMappingURL=ApiKeysService.js.map